import { render, staticRenderFns } from "./CandidateProfile.vue?vue&type=template&id=77c63e66&scoped=true"
import script from "./CandidateProfile.vue?vue&type=script&lang=js"
export * from "./CandidateProfile.vue?vue&type=script&lang=js"
import style0 from "./CandidateProfile.vue?vue&type=style&index=0&id=77c63e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c63e66",
  null
  
)

export default component.exports